import { DefaultError } from "../../-components/error-context"
import { useThrowError } from "../../-components/error-context/use-error"

export function useHandleAsyncSafely<T>() {
  const throwError = useThrowError()

  return async function handleAsyncSafely(
    // args and return can be anything so we handle it
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    asyncFn: (...args: any[]) => Promise<T>,
    options?: { withoutErrorBoundary?: boolean }
  ) {
    try {
      return await asyncFn()
    } catch (error) {
      const handledError = error as DefaultError
      if (
        handledError.status === 400 ||
        handledError.response?.status === 400 ||
        (handledError.status === 401 && handledError.LockSeconds)
      ) {
        return await Promise.reject(handledError)
      } else {
        if (!options?.withoutErrorBoundary) {
          throwError(handledError)
        }
        throw error
      }
    }
  }
}
